<template>
  <section class="content">
      <!-- <div class="box box-info"> -->
        <form >
            <website ref="website"/>
            <div class="name">
            <div class="page section-header text-center">
              <h1 >About Us</h1>
            </div>
            <div class="page-width">
              <div class="rte"></div>
              <div class="page-width">
                <div class="custom-content"> 
                <div class="custom__item custom__item--1537787486018 one-whole align--center">
                  <div class="medium-up--text-center">

    <h2 class="h2"> LILPICKS- FASHION FOR LIL ONES</h2>
    <div class="rte-setting">
<p>
LilPicks is a child-centered brand focusing on styling the little bundles of joy since it's inception in the year, 2015. The idea of LilPicks came from a mother and budding entrepreneur,
 Mrs. Riya Gupta (Founder, LilPicks) with a determination in mind to venture into the section of kids to make them look trendy.
</p>
Over a span of just 4+ years, LilPicks has triumphantly delivering kids garments catering to all the needs of every season. From
festivals, birthdays, to weddings, and casual, semi-formal, formal, Indian, westerns, Indo western to top trends, LilPicks has all that you need for your kid to go all glam-sham!
<p>
The brand takes an extra care of the comfort of the child while also keeping in mind the latest fashion trends. The use of cotton lining
and threads makes our garments highly appreciated not only by the children but in accordance with the standards of clothing. We pay keen attention to each child’s body 
structure and their age to ensure the suitability of the garment.
</p>
With subject to fashion, LilPicks is one of the most loved brands in the Kids section of E-Commerce Marketplace like Myntra, Firstcry,
Hopscotch, LittleMuffet, AJIO, Shopperstop And Many More……..
<p>
We Have Supplies to Many Curated Retail Stores Pan India.
</p>
In 2020, We started catering worldwide and Successful Delivered Orders to Singapore, Malaysia and Dubai.
<p>
Let your little one vouch of his amazing Picks at LilPicks!
</p>
    </div>
                  </div>
                </div>

                </div>
              </div>

            </div>
      </div>
      <footerWebsite ref="footerWebsite"/>
</form>
    <!-- </div> -->
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import Dataview from 'primevue/dataview'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import accountMasterDialog from '../accountDialog/AccountMasterDialog'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
export default {
  name: 'aboutUs',
  props: ['aboutUs'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      sortOptions: [
       {label: 'Price High to Low', value: '!price'},
       {label: 'Price Low to High', value: 'price'}
      ],
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    accountMasterDialog,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria,
    Dataview,
    website,
    footerWebsite
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
</style>



// WEBPACK FOOTER //
// aboutUs.vue?757ac324